<template>
  <div class="cc-scene">
    <div
      class="cc-card"
      :class="{ flipped: isFlipped }"
      @click="flipCard"
      role="button"
      aria-label="Cartão de crédito"
    >
      <!-- Frente -->
      <div class="cc-face cc-front">
        <div class="cc-shine"></div>
        <div class="cc-front__top">
          <div class="cc-chip"><span></span><span></span><span></span></div>
          <div class="cc-brand">
            <v-icon v-if="data.current" color="white" small class="mr-1"
              >mdi-check-decagram</v-icon
            >
            <span class="cc-brand__text">pitch</span>
          </div>
        </div>

        <div class="cc-number">{{ displayNumber }}</div>

        <div class="cc-front__bottom">
          <div class="cc-field">
            <span class="cc-label">Titular</span>
            <span class="cc-value cc-holder">{{ displayHolder }}</span>
          </div>
          <div class="cc-field cc-field--right">
            <span class="cc-label">Validade</span>
            <span class="cc-value">{{ displayExpiry }}</span>
          </div>
        </div>
      </div>

      <!-- Verso -->
      <div class="cc-face cc-back">
        <div class="cc-stripe"></div>
        <div class="cc-signature">
          <span class="cc-signature__label">CVV</span>
          <span class="cc-cvv">{{ displayCvv }}</span>
        </div>
        <p class="cc-back__note">
          Seus dados são tokenizados e armazenados com segurança pela
          administradora de cartões.
        </p>
        <div class="cc-brand cc-brand--back">
          <span class="cc-brand__text">pitch english</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardTemplate",
  props: {
    checkout: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isFlipped: false,
    };
  },
  computed: {
    displayNumber() {
      const raw = String(this.data.maskedNumber || "").trim();
      if (!raw) return "•••• •••• •••• ••••";
      // Completa visualmente ate 16 digitos com placeholders.
      const digits = raw.replace(/\s+/g, "");
      const padded = (digits + "••••••••••••••••").slice(0, 16);
      return padded.replace(/(.{4})/g, "$1 ").trim();
    },
    displayHolder() {
      return (
        String(this.data.holder || "")
          .trim()
          .toUpperCase() || "SEU NOME"
      );
    },
    displayExpiry() {
      const month = this.data.expMonth || "••";
      const year = String(this.data.expYear || "••••").slice(-2);
      return `${month}/${year}`;
    },
    displayCvv() {
      const cvv = String(this.data.cvv || "").trim();
      return cvv || "•••";
    },
  },
  methods: {
    flipCard() {
      this.isFlipped = !this.isFlipped;
    },
    setFlipped(value) {
      this.isFlipped = !!value;
    },
  },
};
</script>

<style scoped>
.cc-scene {
  perspective: 1200px;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  padding: 8px;
}

.cc-card {
  position: relative;
  width: 100%;
  aspect-ratio: 1.586;
  transform-style: preserve-3d;
  transition: transform 0.7s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
  animation: cc-float 6s ease-in-out infinite;
}

.cc-card:hover {
  transform: translateY(-6px) rotateX(4deg);
}

.cc-card.flipped {
  transform: rotateY(180deg);
}

.cc-card.flipped:hover {
  transform: rotateY(180deg) translateY(-6px);
}

.cc-face {
  position: absolute;
  inset: 0;
  border-radius: 18px;
  padding: 22px;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  box-shadow: 0 18px 40px -12px rgba(107, 18, 51, 0.55),
    inset 0 1px 1px rgba(255, 255, 255, 0.25);
}

/* Paleta do aluno (rosa/magenta) */
.cc-front {
  background: linear-gradient(135deg, #ff5595 0%, #e8276f 45%, #6b1233 100%);
}

.cc-back {
  background: linear-gradient(135deg, #8c1843 0%, #6b1233 60%, #47103a 100%);
  transform: rotateY(180deg);
}

/* Brilho diagonal que percorre o cartao */
.cc-shine {
  position: absolute;
  top: -60%;
  left: -30%;
  width: 60%;
  height: 220%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.35) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: rotate(20deg);
  animation: cc-sweep 5s ease-in-out infinite;
  pointer-events: none;
}

.cc-front__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cc-chip {
  width: 46px;
  height: 34px;
  border-radius: 7px;
  background: linear-gradient(135deg, #f6d365 0%, #d9a441 100%);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3px;
  padding: 6px;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.25);
}
.cc-chip span {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}

.cc-brand {
  display: flex;
  align-items: center;
}
.cc-brand__text {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.cc-brand--back {
  margin-top: auto;
  justify-content: flex-end;
  opacity: 0.85;
}

.cc-number {
  margin-top: auto;
  font-family: "Work Sans", monospace;
  font-size: clamp(1.1rem, 5vw, 1.55rem);
  letter-spacing: 3px;
  font-weight: 600;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.cc-front__bottom {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 16px;
}

.cc-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.cc-field--right {
  align-items: flex-end;
}
.cc-label {
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.7;
}
.cc-value {
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.cc-holder {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Verso */
.cc-stripe {
  height: 42px;
  margin: 6px -22px 16px;
  background: rgba(0, 0, 0, 0.55);
}
.cc-signature {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  background: repeating-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.85),
    rgba(255, 255, 255, 0.85) 6px,
    rgba(255, 255, 255, 0.65) 6px,
    rgba(255, 255, 255, 0.65) 12px
  );
  border-radius: 6px;
  padding: 8px 12px;
  color: #6b1233;
}
.cc-signature__label {
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}
.cc-cvv {
  font-family: "Work Sans", monospace;
  font-weight: 700;
  letter-spacing: 2px;
}
.cc-back__note {
  font-size: 0.62rem;
  opacity: 0.8;
  margin-top: 14px;
  line-height: 1.4;
}

@keyframes cc-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
.cc-card.flipped {
  animation: none;
}

@keyframes cc-sweep {
  0% {
    left: -40%;
  }
  60%,
  100% {
    left: 130%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cc-card,
  .cc-shine {
    animation: none;
  }
}
</style>
